module.exports = __webpack_public_path__ + "assets/img/openinvest-get-started-w540.c1620542.jpg";